<script setup>
  import { computed, ref, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { formatDateTime } from '../../utils/format_offer';
  import { useCartRefundStore } from '../../stores/CartRefundStore';

  const { t } = useI18n();
  const props = defineProps({
    cartId: {
      type: Number,
      required: true,
      default: 0
    }
  });
  const CartRefundStore = useCartRefundStore();

  const cartRefunds = computed(() => {
    return CartRefundStore.cart_refunds || [];
  });

  const mountLinkToDownload = (refundId, type = 'csv') => {
    return `/carts/${props.cartId}/refunds/${refundId}.${type}`;
  }

  onMounted(() => {
    CartRefundStore.fetchCartRefunds(props.cartId)
  });
</script>

<template>
  <div class="row" v-if="cartRefunds.length">
    <div class="col-4">
      <p class="d-inline-flex gap-1">
        <a class="btn btn-primary" data-bs-toggle="collapse" href="#refund-copies-list" role="button" aria-expanded="false" aria-controls="refund-copies-list">
          {{ t('cart.refund.refund_copies.title', cartRefunds.length ) }}
          <i class="bi bi-caret-down-fill"></i>
        </a>
      </p>
      <div class="collapse" id="refund-copies-list">
        <div class="card card-body pb-1">
          <div class="row mb-2" v-for="item in cartRefunds">
            <div class="col-8">
              {{ t('cart.refund.refund_copies.date_of_refund') }}: {{ formatDateTime(new Date(item.created_at)) }}
            </div>
            <div class="col-4 text-end">
              <a target="_blank" :href="mountLinkToDownload(item.id, 'csv')" class="fs-3">
                <i class="bi bi-filetype-csv"></i>
              </a>
              <a target="_blank" :href="mountLinkToDownload(item.id, 'xlsx')" class="fs-3">
                <i class="bi bi-filetype-xlsx"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
